<template>
  <div class="m-content">
	<template v-for="item in results">
    <HeaderBox/>
    <div class="report-content">
      <div class="introdution">
        <p>总体来说，你在To Do List上的任务完成率为<span class="text-emphasis">{{complete}}</span>。</p>
        <p>To Do List上列出的28件任务，是你在大学期间需要完成的必修课。如果完成的很好，就可以顺利的过渡到下一阶段。如果没有完成，它们不会自动消失，没有解决的这些困惑/疑问会一直跟着你走，直到你补课完成它。补得越晚，累积的任务越多，补课成本就越大。</p>
        <p>这28件任务其实可以分为3大类共7小类，你在每小类上的任务完成情况如何呢？下面是详细的测评结果解读。</p>
      </div>
      <div class="report-big">
        <p>
          <i class="iconfont icon-street-view"></i>
          自我管理
        </p>
      </div>
      <div class="report-area">
        <p class="report-title">自我认知</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.自我认知"></p>
      </div>
      <div class="report-area">
        <p class="report-title">生活管理</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.生活管理"></p>
      </div>
      <div class="report-big">
        <p>
          <i class="iconfont icon-book"></i>
          教育&职业探索
        </p>
      </div>
      <div class="report-area">
        <p class="report-title">职业认知</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.职业认知"></p>
      </div>
      <div class="report-area">
        <p class="report-title">人际询问</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.人际询问"></p>
      </div>
      <div class="report-area">
        <p class="report-title">工作机会探索</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.工作机会探索"></p>
      </div>
      <div class="report-big">
        <p>
          <i class="iconfont icon-download"></i>
          决策&规划
        </p>
      </div>
      <div class="report-area">
        <p class="report-title">生涯决策</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.生涯决策"></p>
      </div>
      <div class="report-area">
        <p class="report-title">生涯规划</p>
        <p v-html="item.cosTodolist.mapSecondDimDesc.生涯规划"></p>
      </div>
    </div>
    <FootBox :id="id"/>
	</template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'ToDoReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      results:[],
      complete:'0%'
    };
  },
	computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
	},
  created: function () {
    this.getReport()
    setWechatTitle('生涯驿站-大学生ToDoList')
  },
  methods:{
    getReport(result){
        this.results=[];
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosTdlReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            const mbtiResult = response.data.data;
            this.results.push(mbtiResult)
            let answer = mbtiResult.cosTodolist.answer
            let num = answer.match(/\$0/g).length
            this.complete = parseInt((num/28)*100)+"%"
          }
        })
        .catch((error)=>{
          console.log(error)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .text-emphasis
    font-size:0.4rem
</style>
